module.exports = __webpack_public_path__ + "images/category_lp/brand/store_images/4_e0c7f0f85b2795786e5642f261b39b69.png";